import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Gallery, GalleryItem, ImageSize, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { splitAtColon } from '@angular/compiler/src/util';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';

export interface Element {
  title: string;
  source: number;
  languages: number;
  publishDate: string;
  updatedBy: string;
  action: boolean;
}

interface sortBy {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-news-historical-data',
  templateUrl: './news-historical-data.component.html',
  styleUrls: ['./news-historical-data.component.scss'],
})
export class NewsHistoricalDataComponent implements OnInit {
  statedata;
  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = [
    'thumbnail',
    'publishDate',
    'title',
    'source',
    'languages',
    'updatedBy',
    'action',
  ];
  dataSource = new MatTableDataSource<Element>([]);

  getAverageData: any = [];
  averageData;
  userdata;
  newDataList = [];
  newData;

  selectedSorting: string;
  selectFilterData1;

  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
    { value: '5', viewValue: 'Custom Date' },
  ];

  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  filterData = [
    //  { value: '0', viewValue: 'App Version' },
    { value: '1', viewValue: 'State' },
    //{ value: '2', viewValue: 'Language' },
  ];

  selectFilterData;
  searchData = '';
  filterbyText = '';

  filterbylanguage = '';

  public matChipArray = [];
  exportcsvdata = false;
  removable = true;
  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;
  customDate = false;

  languages = new FormControl();
  languageList: any = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];

  languageMap: any = {
    te: 'Telugu',
    ta: 'Tamil',
    kn: 'Kannada',
    ml: 'Malayalam',
    en: 'English',
    hi: 'Hindi',
  };

  dateRangeMaxDate = new Date();
  editNews = false;
  newsform: FormGroup;
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  response;
  submitted = false;
  selected;
  ranges: any = {
    // 'Today': [moment(), moment()],
    // 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };

  // maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
  // minDate = new Date();
  maxDate;
  minDate;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);
    this.newsform = this.fb.group({
      newsId: ['', [Validators.required]],
      newsTitle: ['', [Validators.required]],
      newsSource: ['', [Validators.required]],
      attachlink: ['', [Validators.pattern(this.reg)]],
      languages: [],
      // remark: ['', [Validators.required]],
      date: [new Date()],
    });

    this.averageNews();
    this.getnewsData();
  }

  openDatepicker() {
    this.pickerDirective.open();
  }

  // onDateRangeChanged(){
  // }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getLanguages(ls) {
    let languages = [];
    if (ls && ls?.length == 0) return '';
    let larray = ls?.split(',');
    if (larray && larray.length != 0) {
      larray.forEach((key) => {
        languages.push(this.languageMap[key.trim()]);
      });
      return languages.join(', ');
    }
  }
  getnewsData() {
    this.spinner.show();
    var postdata = {
      fromDate: '',
      toDate: '',
      search: '',
      languages: '',
      pageNumber: 0,
      pageSize: 0,
    };

    this._userService.getNewsListHistoricalData(postdata).subscribe((data) => {
      this.newData = data;

      this.paginationProperty = this.newData.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.newData.result.data.list
      );

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }

  averageNews() {
    this._userService.getAverageNews().subscribe((data) => {
      this.averageData = data;
      this.getAverageData = this.averageData.result.data;
    });
  }

  formPage() {
    this.editNews = true;
    this.router.navigate(['/add-news']);
  }

  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  selectItem(item) {
    if (item.value == 'Custom Date') {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }

  startdata;
  enddata;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd HH:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd HH:mm:ss')
        : null;
    }
  }

  /*=========================================== apply filter ======================================================================== */
  filterbylanguageName = '';
  languageName = '';
  filterbyformdate = '';
  filterbytodayte = '';
  filterbysource = '';
  source: '';
  subProductName: '';
  filterbysubProductName: '';
  sharedate;
  filterbysharedate = '';
  formdate = this.datePipe.transform(
    this.form.controls.start.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  todayte = this.datePipe.transform(
    this.form.controls.end.value,
    'yyyy/MM/dd hh:mm:ss'
  );
  applyfilter(checkEmpty) {
    if (
      checkEmpty &&
      !this.searchData &&
      !this.languageName &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbylanguageName = this.languageName;
      this.filterbysource = this.source;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;

      let indexlanguageName = this.matChipArray.findIndex(
        (x) => x.tag === 'languageName'
      );
      //let indexsource = this.matChipArray.findIndex(x => x.tag === 'source');
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );

      if (this.languageMap[this.languageName] != '') {
        if (indexlanguageName > -1) {
          this.matChipArray[indexlanguageName].name =
            'Language' + ':' + this.languageMap[this.languageName];
        } else {
          if (
            this.languageMap[this.languageName] != '' &&
            this.languageMap[this.languageName] != undefined
          ) {
            this.matChipArray.push({
              name: 'Language' + ':' + this.languageMap[this.languageName],
              tag: 'languageName',
              flag: true,
            });
          }
        }
      }

      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('MM/DD/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('MM/DD/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('MM/DD/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('MM/DD/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }

      // if (this.startdata != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indexformdate].name = "Start Date" + ":" + this.datePipe.transform( this.startdata, 'dd/MM/yyyy');
      //   } else {

      //     if (this.startdata != "" && this.startdata != undefined) {
      //       this.matChipArray.push({ 'name': "Start Date" + ":" + this.datePipe.transform( this.startdata, 'dd/MM/yyyy'), 'tag': 'startdata', 'flag': true })
      //     }

      //   }
      // }

      // if (this.enddata != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indextodayte].name = "End Date" + ":" + this.datePipe.transform(this.enddata, 'dd/MM/yyyy');
      //   } else {

      //     if (this.enddata != "" && this.enddata != undefined) {
      //       this.matChipArray.push({ 'name': "End Date" + ":" + this.datePipe.transform(this.enddata, 'dd/MM/yyyy'), 'tag': 'enddata', 'flag': true })
      //     }

      //   }
      // }
      // this.formdate = this.datePipe.transform(this.form.controls.start.value, 'yyyy/MM/dd hh:mm:ss');
      // this.todayte = this.datePipe.transform(this.form.controls.end.value,'yyyy/MM/dd hh:mm:ss');
      // if(this.customDate == true)
      //{
      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        languages: this.filterbylanguageName,
        pageNumber: 0,
        pageSize: 10,
      };
      //  }
      // else{
      //    postdata = {
      //     "fromDate": this.startData,
      //     "todate": this.enddata,
      //     "search": this.filterbyText,
      //     "languages": this.filterbylanguageName,
      //     "pageNumber": 0,
      //     "pageSize": 10
      //   }
      // }

      this._userService
        .getNewsListHistoricalData(postdata)
        .subscribe((data) => {
          this.newData = data;
          this.paginationProperty = this.newData.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.totalPages = this.paginationProperty.totalPages;
          this.dataSource = new MatTableDataSource<Element>(
            this.newData.result.data.list
          );

          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    }
  }

  remove(index, tag): void {
    if (tag === 'languageName') {
      this.matChipArray.splice(index, 1);
      this.languageName = '';
    }

    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    setTimeout(() => {
      this.applyfilter(false);
    }, 500);
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }
  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        languages: this.filterbylanguageName,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService
        .getNewsListHistoricalData(postdata)
        .subscribe((data) => {
          this.userdata = data;
          this.newData = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.dataSource = new MatTableDataSource(this.newData);
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    } else {
      postdata = {
        fromDate: '',
        todate: '',
        search: '',
        languages: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService
        .getNewsListHistoricalData(postdata)
        .subscribe((data) => {
          this.userdata = data;
          this.newData = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.dataSource = new MatTableDataSource(this.newData);
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  //edit row fuctionality //

  listdata1;
  publisDate;
  editPage(data1) {
    this.editNews = true;
    this.listdata1 = data1;
    let newDate =
      data1.publishDate.split('/')[1] +
      '/' +
      data1.publishDate.split('/')[0] +
      '/' +
      data1.publishDate.split('/')[2];
    let prefillDate = this.datePipe.transform(newDate, 'MM/dd/yyyy HH:mm:ss');
    this.newsform.get('newsId').setValue(data1.newsId);
    this.newsform.get('newsTitle').setValue(data1.title);
    this.newsform
      .get('languages')
      .setValue(data1.languages.replaceAll(',', '').split(' '));
    this.newsform.get('newsSource').setValue(data1.source);
    this.newsform.get('attachlink').setValue(data1.newsLink);
    this.newsform.get('date').setValue(new Date(prefillDate));
  }
  newsTitle;
  Remark;
  Source;
  onSubmit() {
    this.submitted = true;
    let x;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe((data) => {
      x = data;
      if (this.newsform.valid && x) {
        if (this.newsform.value.attachlink != '') {
          var pattern = new RegExp(this.reg);
          var result = pattern.test(this.newsform.value.attachlink);
          if (result == false) {
            alert('Please enter valid attach link');
            return false;
          }
        }

        let newsId = this.newsform.value.newsId;
        this.spinner.show();

        let date =
          this.datePipe.transform(
            this.newsform.controls.date.value,
            'yyyy-MM-dd'
          ) +
          ' ' +
          this.datePipe.transform(new Date(), 'HH:mm:ss.sss');

        var formdata = {
          title: this.newsform.value.newsTitle,
          languages: this.newsform.value.languages,
          publishDate: date,
          newsLink: this.newsform.value.attachlink,
          source: this.newsform.value.newsSource,
          remark: this.newsform.value.remark,
          newsId: this.newsform.value.newsId,
        };

        // if (confirm("Do you want to share this news?")) {
        this._userService.updateNews(formdata).subscribe((data) => {
          this.response = data;
          this.spinner.hide();
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
        });
        //  }
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/news-historical-data']);
          this.spinner.hide();
        });
      }
    });
  }
  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }

  listPage() {
    this.editNews = false;
  }

  // delete row functionality //
  newsId1;
  openDialog(data2): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    const dialogRef = this.dialog.open(DeleteNewsRow, {
      // width: '30%',
      // height: '27%',
      data: { id: data2.newsId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.applyfilter(false);
      this.averageNews();
    });
  }

  dialogresult;
  mainresult;
  apidata;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(NewsExportData, {
      width: '60%',
      height: '53%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);

          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);
              if (this.customDate == true) {
                var postdata = {
                  fromDate: this.formdate,
                  todate: this.todayte,
                  search: this.filterbyText,
                  languages: this.filterbylanguageName,
                  reportList: Result,
                };
              } else {
                postdata = {
                  fromDate: this.startdata,
                  todate: this.enddata,
                  search: this.filterbyText,
                  languages: this.filterbylanguageName,
                  reportList: Result,
                };
              }
              this._userService.exportNews(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'newsData.xlsx';
                anchor.href = url;
                anchor.click();
              });
            } else {
              var postdata = {
                search: '',
                fromDate: '',
                todate: '',
                languages: '',
                reportList: Result,
              };
              this._userService.exportNews(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'newsData.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
      //================================REPORT GENERATE==========================================//
    });
  }
}

// delete row popup functinality //
@Component({
  selector: 'delete-news-row',
  templateUrl: 'delete-news-row.html',
})
export class DeleteNewsRow {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<DeleteNewsRow>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }

  onSubmit() {
    if (this.formdelet.valid) {
      var postdata = {
        newsId: this.data.id,
        remark: this.formdelet.value.Remark,
      };
      this._userService.removeNews(postdata).subscribe((data) => {
        this.response = data;
        //window.location.reload();
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}

// New Export Data functinality //
@Component({
  selector: 'news-export-data',
  templateUrl: 'news-export-data.html',
})
export class NewsExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<NewsExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Title', value: 'Title', isSelected: false },
      { id: 2, viewValue: 'Source', value: 'Source', isSelected: false },
      { id: 3, viewValue: 'News Link', value: 'NewsLink', isSelected: false },
      {
        id: 4,
        viewValue: 'Publish Date',
        value: 'PublishDate',
        isSelected: false,
      },
      { id: 5, viewValue: 'Bookmark', value: 'Bookmark', isSelected: false },
      { id: 6, viewValue: 'Languages', value: 'Languages', isSelected: false },
      //{ id: 6, value: 'Updated By', isSelected: false }
    ];
    this.getCheckedItemList();
  }

  ngOnInit(): void {}

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
